import React , {useEffect,useState, useRef} from "react";
import lineLV from "../../assets/images/lineLV.png"
import lineRV from "../../assets/images/lineRV.png"
import Cardcarousel from "../cardcarousel/Cardcarousel"
import styles from "./game.module.css"
const Game = () => {
    const [scrollPosition, setScrollPosition] = useState(0);
    const titleRef = useRef(null);
    const requestRef = useRef();

    useEffect(() => {
        const handleScroll = () => {
            requestRef.current = requestAnimationFrame(() => {
                const titleTop = titleRef.current.offsetTop;
                const titleHeight = titleRef.current.offsetHeight;
                const scrollTop = window.scrollY;
                const scrollBottom = scrollTop + window.innerHeight;

                // check if the title is in view
                if (scrollTop < titleTop + titleHeight && scrollBottom > titleTop) {
                    const progress = (scrollBottom - titleTop) / (titleHeight + window.innerHeight);
                    setScrollPosition(progress);
                } else {
                    setScrollPosition(0);
                }
            });
        }
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            cancelAnimationFrame(requestRef.current);
        };
    }, []);

    const titleStyle = {
        background: `linear-gradient(to left, #5618C5 ${scrollPosition * 180}%, transparent 0)`,
      };

    return (
        <div className={styles.containerGames}>
          
                <div className={styles.containerTitle}>
                    <img className={styles.lineFront} src={lineRV} alt="lineR"></img>
                    <div className={styles.titleBackground}>
                        <h1 ref={titleRef} style={titleStyle} className={styles.titleText}>بیش از ۳۰ بازی جذاب</h1>
                    </div>
                    <img className={styles.lineFront} src={lineLV} alt="lineL"></img>
                </div>
                <div className="carouselContain">
                    <Cardcarousel />
                </div>
          
        </div>
    )
}
export default Game;
